import { DataLayer } from "@allwyn/utils/data-layer";
import { ResponsiveUtils } from "@allwyn/utils/responsive-utils";

/* eslint-disable @typescript-eslint/naming-convention */
export const HrajSRozumemAnalytics = {
    pushPageLoad: (): void => {
        DataLayer.push({ session: { ABTests: [] } });
        ResponsiveUtils.logDataLayer();
        DataLayer.push({
            event: "pageReady",
        });
    },
    pushContactFormSubmit: (): void => {
        DataLayer.push({
            event: "action.submit.contactForm",
        });
    },
    actionShowPromo: (id: string, name: string, relativeImgUrlOrText: string, position: string): void => {
        DataLayer.pushInstant({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [
                        {
                            id: id,
                            name: name,
                            creative: getCreative(relativeImgUrlOrText),
                            position: position,
                        },
                    ],
                },
            },
        });
    },
    actionImpressPromo: (id: string, name: string, relativeImgUrlOrText: string, position: string): void => {
        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: id,
                            name: name,
                            creative: getCreative(relativeImgUrlOrText),
                            position: position,
                        },
                    ],
                },
            },
        });
    },
};

function getCreative(relativeImageUrl: string): string {
    return (relativeImageUrl || "").startsWith("/") ? window.location.hostname + relativeImageUrl : relativeImageUrl;
}
